import React from 'react';
import './Form.css';

const Button = ({
    children,
    variant = 'primary',
    size = 'medium',
    loading = false,
    ...props
}) => {
    return (
        <button
            className={`form-button form-button-${variant} form-button-${size}`}
            disabled={loading || props.disabled}
            {...props}
        >
            {loading ? 'Loading...' : children}
        </button>
    );
};

export default Button;

